import React, {Fragment} from 'react';
import './App.scss';
import { Outlet } from 'react-router-dom';
import useViewerExternalSetup from './components/views/home/viewer/use-viewer-external-setup';

const App = () => {
  // * Height and width are measured in percentages
  const {unityPlayerCanvasRef, unityPlayerCanvasBuilt,unityPlayerCanvasIsBeingUsed} = useViewerExternalSetup({
    width: 100,
    height: 100
  });
  
  return (
     <Fragment>
      <main id="app-main-content"><Outlet context={{unityPlayerCanvasBuilt, unityPlayerCanvasRef}}/></main>
      {!unityPlayerCanvasIsBeingUsed && unityPlayerCanvasBuilt}
     </Fragment>
  );
}

export default App;
